<template>
  <div id="app" >
    <keep-alive>
      <router-view ref="dashboard"></router-view>
    </keep-alive>
  </div>
</template>

<script>
    export default {
        name: 'xuezhi',

    }
</script>

<style lang="scss">

</style>
